export default __webpack_public_path__ + "static/media/moon-of-appalacia.0d34b444.jpg";